module.exports = __webpack_public_path__ + "img/jose-eduardo.40ffed8f.jpg";